export enum ZIndexLayer {
  NewsletterArticleFloatingWidget = 1000,
  ArticleAuthorFollowButton = 1001,
  AppTooltip = 1100,
  TakeoverAd = 1101,
  StoryCardCarouselWidget = 1102,
  NewsletterArticleIssues = 1200,
  PlusDatePicker = 1202,
  AppBar = 1300,
  DropdownSelect = 1350,
  Drawer = 1400,
  Modal = 1500,
  SnackBar = 1600,
  AlertBox = 1700,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Tooltip = 1700,
  HamburgerMenu = 1800,
  EditionInvitation = 1900,
  GoogleOneTapSignIn = 2000,
  PlusPopup = 2100,
  PlusListingPopup = 2200,
  TypeformFloatingButton = 2300,
  TypeformPopupOverlay = 2350,
  OnboardingDialog = 3000,
  LiveUpdateAlert = 4000,
}
